


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"



window.spaWidgetParams = window.spaWidgetParams || {};
                       window.spaWidgetParams['global-search-public-widget'] = window.spaWidgetParams['global-search-public-widget'] || {};
                       window.spaWidgetParams['global-search-public-widget']['2.0.0'] = window.spaWidgetParams['global-search-public-widget']['2.0.0'] || {};
window.spaWidgetParams['global-search-public-widget']['2.0.0'].dynamicImportMap = {
  modules: [

  ],
}



window.spaWidgetParams['global-search-public-widget']['2.0.0'].getBootstrapUtilityInstance = function () { return spartaBootstrapUtility; };
